export enum MULTI_REACTIONS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=640217556
     */
    CHANGE_REACTION_ARIA_LABEL = 'MULTI_REACTIONS.CHANGE_REACTION_ARIA_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=640217780
     */
    REACT_ARIA_LABEL = 'MULTI_REACTIONS.REACT_ARIA_LABEL',
}
